import { render } from "./CollapseMenuBorderless.vue?vue&type=template&id=a9b1b2ac"
import script from "./CollapseMenuBorderless.vue?vue&type=script&lang=js"
export * from "./CollapseMenuBorderless.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/CollapseMenuBorderless.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9b1b2ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9b1b2ac', __exports__)) {
    api.reload('a9b1b2ac', __exports__)
  }
  
  module.hot.accept("./CollapseMenuBorderless.vue?vue&type=template&id=a9b1b2ac", () => {
    api.rerender('a9b1b2ac', render)
  })

}


export default __exports__